/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClickBackgroundUploadEndpointRequest
 */
export interface ClickBackgroundUploadEndpointRequest {
    /**
     * 
     * @type {number}
     * @memberof ClickBackgroundUploadEndpointRequest
     */
    gallery: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ClickBackgroundUploadEndpointRequest
     */
    linksToSend: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof ClickBackgroundUploadEndpointRequest
     */
    notifyOnCompletion: boolean;
}

export function ClickBackgroundUploadEndpointRequestFromJSON(json: any): ClickBackgroundUploadEndpointRequest {
    return ClickBackgroundUploadEndpointRequestFromJSONTyped(json, false);
}

export function ClickBackgroundUploadEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClickBackgroundUploadEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'gallery': json['gallery'],
        'linksToSend': json['links_to_send'],
        'notifyOnCompletion': json['notify_on_completion'],
    };
}

export function ClickBackgroundUploadEndpointRequestToJSON(value?: ClickBackgroundUploadEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'gallery': value.gallery,
        'links_to_send': value.linksToSend,
        'notify_on_completion': value.notifyOnCompletion,
    };
}


